<template>
    <v-menu
            v-model="menu"
            :close-on-click="false"
            :close-on-content-click="false"
            :nudge-width="300"
            max-width="450"
            offset-x
    >
        <template v-slot:activator="{ on }">
            <v-btn :icon="iconOnly" :color="color" depressed :outlined="outlined" :block="block" dark v-on="on">
                <v-icon v-text="icon"></v-icon>
                <slot></slot>
            </v-btn>
        </template>
        <contact-form v-if="menu" v-bind="contact" v-bind:event-id="eventId" :set-contact-type-id="contactTypeId" :title="title" @onClose="onClose"></contact-form>
    </v-menu>
</template>

<script>

    import contactForm from './ContactForm'

    export default {
        name: 'contact-menu-button',
        components: {
            contactForm,
        },
        data() {
            return {
                menu: false,
            }
        },
        props: {
            iconOnly: {
                type: Boolean,
                default: true,
            },
            block: {
                type: Boolean,
                default: false,
            },
            outlined: {
                type: Boolean,
                default: true,
            },
            eventId: {
                type: Number,
                required: true,
            },
            icon: {
                type: String,
                default: 'add',
            },
            title: {
                type: [String, null],
                default: null,
            },
            color: {
                type: String,
                default: 'grey darken-1',
            },
            contactTypeId: {
                type: [Number, null],
                default: null,
            },
            contact: {
                type: Object,
                default: () => ({
                    id: null,
                    contactTypeId: 4,
                    contactTypeName: null,
                    deviceId: null,
                    prefix: null,
                    title: null,
                    name: null,
                    suffix: null,
                    number: null,
                    code: null,
                    type: null,
                    icon: null,
                    custom: 1,
                    persistent: 0,
                })
            },
        },
        methods: {
            onClick() {
                this.menu = true;
            },
            onClose() {
                this.menu = false;
            },
        }
    }
</script>
